import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "orderBy"
})
export class OrderByPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(array: any[], field: string, isAsc: boolean = true): any[] {
    return array.sort((a, b) => {
      if (a[field] < b[field]) return (isAsc) ? -1 : 1;
      else if (a[field] > b[field]) return (isAsc) ? 1 : -1;
      else return 0;
    });
  }
}